import { EGrads } from 'libs/styles/styling';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const GradientLine = (props: Props): JSX.Element => {
    return <S_GradientLine className={props.className} />;
};

const S_GradientLine = styled.div`
    width: 100%;
    height: 1px;
    background: ${EGrads.ACC2_GRAD};
`;
